export const GTM_EVENTS = Object.freeze({
  EXPERIMENT_IMPRESSION: 'experiment_impression',
  GENERATE_LEAD: 'generate_lead',
  GEO_DATA: 'geo_data',
  LANDING_PAGE: 'landing_page',
  LEAD_FORM: 'lead_form',
  PATH_VALIDATION: 'path_validation',
  PAYMENT_DECLINED: 'payment_declined',
  PAYMENT_DOWNLOAD_APP: 'payment_download_app',
  PURCHASE: 'purchase',
  SMS_CLICKED: 'sms_clicked',
  SMS_ERROR: 'sms_error',
  SMS_SENT: 'sms_sent',
  START_QUIZ: 'start_quiz',
  STEP_COMPLETED: 'step_completed',
  SUBSCRIPTION_CANCELLATION_FAILED: 'Subscription Cancellation Failed',
  SUBSCRIPTION_CANCELLATION_PROCESS_STARTED: 'Subscription Cancellation Process Started',
  SUBSCRIPTION_CANCELLATION_REQUESTED: 'Subscription Cancellation Requested (Web)',
  SUBSCRIPTION_DOWNGRADE_REQUESTED: 'Subscription Downgrade Requested (Web)',
  SUBSCRIPTION_PAUSE_REQUESTED: 'Subscription Pause Requested (Web)',
  UPDATE_LEAD_EMAIL_CONSENT: 'update_lead_email_consent',
  UPSELL_DISPLAYED: 'upsell_displayed',
  UPSELL_PURCHASED: 'upsell_purchased',
  IDENTIFY: 'identify',
});
